"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const pattern_library_components_modal_1 = require("@saatva-bits/pattern-library.components.modal");
const pattern_library_hooks_use_breakpoints_1 = require("@saatva-bits/pattern-library.hooks.use-breakpoints");
const ModalBase_module_scss_1 = __importDefault(require("./ModalBase.module.scss"));
/**
 * ModalBase renders differently depending on the breakpoint
 * On mobile it's a drawer, on tablet onwards its a dialog
 *
 * Only handles the logic for showing and closing the modal
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {function} props.closeHandler - callback to close the modal
 * @param {string} props.customLabel - label for a11y
 * @param {import('react').ReactNode} props.children
 * @param {string} props.modalClasses - style classes for the modal component from bit
 * @param {string} props.closeButtonClasses
 * @param {string} props.contentClasses - styles for children container
 */
const ModalBase = ({ isOpen, closeHandler, modalClasses, closeButtonClasses, contentClasses, customLabel, children, ...other }) => {
    const { isMobile } = (0, pattern_library_hooks_use_breakpoints_1.useBreakpoints)('mobile');
    // Fixes flickering when reopening
    if (!isOpen)
        return null;
    const modalLabel = isMobile ? 'Details Drawer' : 'Details Modal';
    const modalClassNames = (0, classnames_1.default)(ModalBase_module_scss_1.default.detailModal, {
        [ModalBase_module_scss_1.default.drawer]: isMobile
    }, modalClasses);
    const closeBtnClassNames = (0, classnames_1.default)({
        [ModalBase_module_scss_1.default.drawerCloseButton]: isMobile,
    }, closeButtonClasses);
    const contentClassNames = (0, classnames_1.default)(ModalBase_module_scss_1.default.content, {
        [ModalBase_module_scss_1.default.drawerContent]: isMobile
    }, contentClasses);
    return (0, jsx_runtime_1.jsx)(pattern_library_components_modal_1.Modal, { type: isMobile ? 'drawer' : 'popup', isModalVisible: isOpen, onModalClose: closeHandler, className: modalClassNames, closeButtonClass: closeBtnClassNames, contentWrapperClassName: contentClassNames, modalLabel: customLabel || modalLabel, ...other, children: children });
};
ModalBase.propTypes = {
    /** Bool that controls if the modal is visible */
    isOpen: prop_types_1.default.bool.isRequired,
    /** Callback to close modal */
    closeHandler: prop_types_1.default.func.isRequired,
    /** Component that will be inserted into the modal */
    children: prop_types_1.default.node.isRequired,
    /** label used for aria descriptors */
    customLabel: prop_types_1.default.string,
    /** Style overrides for modal container */
    modalClasses: prop_types_1.default.string,
    /** Classes for close button for modal */
    closeButtonClasses: prop_types_1.default.string,
    /** style overrides for the container that wraps the children props in the modal */
    contentClasses: prop_types_1.default.string,
};
exports.default = ModalBase;
//# sourceMappingURL=ModalBase.js.map